import { DataModel } from "common/models/utility-models/base-model";

export class StudentsModel extends DataModel {
    first_name: string = '';
    last_name: string = '';
    father_name: string = '';
    mother_name: string = '';
    mobile_number: string = '';
    parentMobileNumber: string = '';
    email: string = '';
    gender: string = '';
    address: string = '';
    age: string = '';
    region_id: string = '';
    state_id: string = '';
    state_name: string = '';
    district_id: string = '';
    name_of_college: string = '';
    college_address: string = '';
    branch_name: string = null;
    branch_id: string = ''
    batch_number: string = '';
    batch_id: string= '';
    unique_batch_id: string = '';
    mentorName: string = '';
    mentorId: string = ''
    mentor_email: string = ''
    mentor_mobile: string = '';
    remarks: string = '';
    profile_pic_path: any = '';
    duration_start: string = '';
    first_year_score: number = null;
    second_year_score: number = null;
    third_year_score: number = null;
    fourth_year_score: number = null;
    first_year2_score: number = null;
    second_year2_score: number = null;
    third_year2_score: number = null;
    fourth_year2_score: number = null;
    first_year_credit: number = null;
    second_year_credit: number = null;
    third_year_credit: number = null;
    fourth_year_credit: number = null;
    student_id: number = null;
    other: string = '';
    district: string = '';
}

export class students{
    profile_pic_path: any;

}
